export const API_URL = 'https://portal-backend-luuby-695d88ad0aff.herokuapp.com'

//export const REACT_APP_STRIPE_KEY = 'pk_test_51NzfwxJ87r8sN9aT9LcDbxu23csAb8y4vy7TT6leIqp3GBoE027gYqMsLOAdXeyS5byb23hgOGKCYgUELtXIEIJM00U421FU9M'
export const REACT_APP_STRIPE_KEY = 'pk_live_51NzfwxJ87r8sN9aTyUqjVysikpiGATnDJCB9uOKGQcQMwuwzKSi6DEo0W7JgHIVoyfknaubxnJMpgWVEYFwMNPh400oOAisEh5'